import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
//Logos
//assets/svg/logo-udd-blanco.svg
import logoUDD from '../../assets/svg/logo-udd-blanco.svg';
import logoM from '../../assets/dist/svg/main.svg';

const NewHeaderInicio = () => {
    const history = useHistory();
    const location = useLocation();
    const [nombrePostulante, setNombrePostulante] = useState('');
    const [codCarr, setCodCarr] = useState('');
    const [nombreCarrera, setNombreCarrera] = useState('');
    const [sede, setSede] = useState('');
    const [cabecera, setCabecera] = useState('');
    const [fase, setFase] = useState('')

    /* useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });
        } else {
            handleCargaDatosIniciales();
        }
    }, []) */
    const handleCargaDatosIniciales = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        /* setNombrePostulante(_params.nombre) *//* 
        setCodCarr()
        setNombreCarrera()
        setSede() */
    }

    const handleBorrarSession = () => {
        sessionStorage.removeItem('stage');
        sessionStorage.removeItem('stageRut');
        sessionStorage.removeItem('stageRutNumerico');
        sessionStorage.removeItem('nombreCompleto');
        sessionStorage.removeItem('codCarrera');
        sessionStorage.removeItem('codsede');
        sessionStorage.removeItem('nombreCarrera');
        sessionStorage.removeItem('fase');
    }

    useEffect(() => {
        let fs = sessionStorage.getItem('fase');
        /* console.log(nc) */
        if (fs === null) { fs = '' }

        if (fs !== '') {
            fs = fs.replace('"', '')
            fs = fs.replace('"', '')
        }
        /* console.log(fs) */
        setFase(fs)
        /* let nc = sessionStorage.getItem('stageNombreCompleto'); */
        let nc = sessionStorage.getItem('nombreCompleto');
        /* console.log(nc) */
        if (nc === null) { nc = '' }

        if (nc !== '') {
            nc = nc.replace('"', '')
            nc = nc.replace('"', '')
        }
        setNombrePostulante(nc.replace('"', ''));

        let cc = sessionStorage.getItem('codCarrera');
        /* console.log(cc) */
        if (cc === null) { cc = '' }
        if (cc !== '') {
            cc = cc.replace('"', '')
            cc = cc.replace('"', '')
        }
        if (cc === null) { cc = '' }
        setCodCarr(cc);

        let nmc = sessionStorage.getItem('nombreCarrera');
        if (nmc === null) { nmc = '' }
        if (nmc !== '') {
            nmc = nmc.replace('"', '')
            nmc = nmc.replace('"', '')
        }
        setNombreCarrera(nmc);

        let se = sessionStorage.getItem('codsede');
        if (se === null) { se = '' }
        if (se !== '') {
            se = se.replace('"', '')
            se = se.replace('"', '')
        }
        setSede(se);

        setCabecera(/* ' - ' + cc +  */' - ' + nmc + ' - ' + se);

    }, [])

    return (
        <>
            <header style={{ position: 'fixed', display: 'grid', zIndex: 99 }} className="site-header">
                <title>Matrícula Web Universidad Del Desarrollo</title>
                <meta name='description' content='Proceso de Matrícula Web Universidad Del Desarrollo.'></meta>
                <div className="site-header__container2">
                    <div style={{ display: 'flex' }}>
                        <div>
                            <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                        </div>
                    </div>
                </div>
            </header>

            <br></br>
            <br></br>
            <br></br>
        </>
    );
}

export default NewHeaderInicio;